import 'uni-pages';
import Vue from 'vue'
import Page from './demo/pages/mall/goods.vue'
createPage(Page)